export const formatCartNotesReport = (order?) => {
  if (!order) return {};
  return {
    ...order,
    customerName: order?.ShopifyCustomer
      ? `${order?.ShopifyCustomer?.firstName} ${order?.ShopifyCustomer?.lastName}`
      : "Guest",
  };
};
